import { SAME_LOWER_HIERARCHY_DATA_SUCCESS } from "./SameLowerHierarchyConstant";

export const sameLowerHierarchyReducer = (state = { sameLowerHierarchyData: [] }, action) => {

    switch (action.type) {
        case SAME_LOWER_HIERARCHY_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                sameLowerHierarchyData: action.payload,
            }
        default:
            return state;
    }

}



